import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { useTranslation } from 'react-i18next';

function SensorCoverageSection() {
  const { t } = useTranslation();
  const sensors = [
    ['01', t('sensors.items.i1_title'), t('sensors.items.i1_copy')],
    ['02', t('sensors.items.i2_title'), t('sensors.items.i2_copy')],
    ['03', t('sensors.items.i3_title'), t('sensors.items.i3_copy')],
    ['04', t('sensors.items.i4_title'), t('sensors.items.i4_copy')],
    ['05', t('sensors.items.i5_title'), t('sensors.items.i5_copy')],
    ['06', t('sensors.items.i6_title'), t('sensors.items.i6_copy')],
    ['07', t('sensors.items.i7_title'), t('sensors.items.i7_copy')],
    ['08', t('sensors.items.i8_title'), t('sensors.items.i8_copy')],
    ['09', t('sensors.items.i9_title'), t('sensors.items.i9_copy'), true],
    ['10', t('sensors.items.i10_title'), t('sensors.items.i10_copy'), true],
  ];
  return (
    <SectionShell id="sensors">
      <div>
        <Kicker>{t('sensors.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">{t('sensors.title')}</h2>
          <p className="text-lg leading-8 text-slate-600">
            {t('sensors.body')}
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {sensors.map(([number, title, copy, isDark]) => (
            <article
              key={number}
              className={`rounded border p-5 ${
                isDark ? 'border-[#070b14] bg-[rgb(16_185_129)] text-white' : 'border-slate-200 bg-white'
              }`}
            >
              <div className="mb-4 h-[2px] w-6 bg-emerald-500" />
              <p className="text-[11px] font-extrabold uppercase text-black">{number}</p>
              <h3 className="mt-2 text-xl font-black">{title}</h3>
              <p className={`mt-3 text-sm leading-6 ${isDark ? 'text-slate-100' : 'text-slate-600'}`}>{copy}</p>
            </article>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}

export default SensorCoverageSection;
